export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const RESET_FILTER_DATA = 'RESET_FILTER_DATA';
export const RESET_PARAMETERS = 'RESET_PARAMETERS';
export const RESET_HR_FILTER = 'RESET_HR_FILTER';
